import React from "react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../../ui/Collapsible";
import { ChevronDown } from "lucide-react";
import { cn } from "../../../lib/utils";

interface DocsAccordionItemProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export function DocsAccordionItem({
  title,
  children,
  defaultOpen = false,
}: DocsAccordionItemProps) {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger className="w-full flex items-center justify-between p-4 text-left border border-[var(--su-border-primary)] bg-[var(--su-bg-secondary)] hover:bg-[var(--su-bg-tertiary)] transition-colors">
        <span className="font-medium text-[var(--su-text-primary)]">
          {title}
        </span>
        <ChevronDown
          className={cn(
            "w-5 h-5 text-[var(--su-text-muted)] transition-transform",
            isOpen && "transform rotate-180",
          )}
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="border-l border-r border-b border-[var(--su-border-primary)] bg-[var(--su-bg-primary)]">
        <div className="p-4 text-[var(--su-text-secondary)]">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}

interface DocsAccordionProps {
  children: React.ReactNode;
  className?: string;
}

export function DocsAccordion({ children, className }: DocsAccordionProps) {
  return <div className={cn("my-6 space-y-0", className)}>{children}</div>;
}
